import sendEventToAec from "./sendEventToAec";

const heartbeatInterval = 5 * 60 * 1000; // 5 minutes

function sendHeartbeat() {
  sendEventToAec({
    tag: "heartbeat",
    event: {
      eventtype: "heartbeat",
    },
  });
}

window.one = window.one || {};
window.one.heartbeatStarted = false;

export default function startHeartbeat() {
  if (window.one.heartbeatStarted) {
    return;
  }

  sendHeartbeat();
  setInterval(() => sendHeartbeat(), heartbeatInterval);
  window.one.heartbeatStarted = true;
}
